import { createStore } from 'vuex'
import { auth } from  './auth.module';

export default createStore({
  state: {
    app: {
      name:'Responsabilidad Social'
    },
    
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  }
})
